import { createFileRoute } from '@tanstack/react-router'
import RelatoriosImoveisPage from '@/pages/relatorios/relatorios-imoveis-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/relatorios/imoveis',
)({
  component: function RelatoriosImoveisRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.RELATORIOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_REPORTS}>
          <RelatoriosImoveisPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
